// extracted by mini-css-extract-plugin
export default {"faqView":"FaqArticleForm_faqView__SQyW3","actionButtons":"FaqArticleForm_actionButtons__-O37+","topBar":"FaqArticleForm_topBar__MmE9W"};